var _path;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgCircleInfo(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M10 18.108a8.108 8.108 0 100-16.216 8.108 8.108 0 000 16.216zM10 4.5V12M10 15.5v-1.25"
  })));
}

export default __webpack_public_path__ + "bbe8d6a3ccf95011a9547d883e4c9a93.svg";
export { SvgCircleInfo as ReactComponent };